import React, { lazy, Suspense } from "react";

const RemoteCsfNew = lazy(() => import("@/csf/components/csfNew/CSFNew"));
import RemoteSpinner from "@/shared/components/Spinner/Spinner";

import Styles from "./CsfNew.module.scss";

const Loading = () => {
  return (
    <div className={Styles.csfSpinnerContainer}>
      <RemoteSpinner />
    </div>
  );
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Csf = (props: Remote.CSF) => {
  return (
    <Suspense fallback={<Loading />}>
      <RemoteCsfNew sofId="asdf" />
    </Suspense>
  );
};

export default Csf;
